<!-- <app-survay-header></app-survay-header> -->
<div class="Main-Cont">
    <div class="Ques-Cont">
        <div class="text-dark fs-5 fw-bold">
            <!-- What is your Gender&#63; -->
            {{qService.currentQuestion.question_text}}
        </div>
        <div class="text-muted fs-6 fw-normal mt-2">
            You can choose only one answer
        </div>
        <div class="Image-Cont">
            <ng-container *ngFor="let Ques of qService.currentQuestion.options">
                <div>
                    <div class="text-center" (click)="selectOption(Ques)">
                        <div class="ImageBadge-Cont">
                            <img 
                            style="width: 50px; height: autox; margin-bottom: 10px;"
                            [src]="Ques['text'] === 'Male' ? '../../../../../assets/image/group-50@2x.png' : '../../../../../assets/image/group-3@2x.png'" alt="" />
                        </div>
                        <div class="text-dark fs-6 fw-bold Gender-Cont">{{Ques['text']}}</div>
                        <input style="border: 2px solid skyblue;" [checked]="ansBody.answer_text == Ques['label']" name="singleselect-radio" type="radio" class="form-check-input" (change)="selectOption(Ques)"/>
                    </div>

                </div>
             
            </ng-container>
        </div>
    </div>
    <div class="footer">
        <div class="text-dark fw-bold fs-4  text-end">Q{{qService.currentQuestion.ques_index}}</div>
        <div class="text-end">
            <button class="btn btn-primary" (click)="next()">Next</button>
        </div>
    </div>
</div>